/* readyEvent
------------------------------------------------------------------------*/
$(function(){
    //メインビジュアル
    const swiper = new Swiper('.box-mainvisual', {
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        loop: true,
        watchSlidesProgress: true,
        speed: 2000,
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
            waitForTransition: false,
        },
        followFinger: false,
        pagination: {
            el: '.swiper-pagination-mainvisual',
            clickable: true,
            renderBullet: function (index, className) {
                const existingTitles = document.querySelectorAll('.swiper-pagination-mainvisual .bullet-title');
                existingTitles.forEach(title => title.remove());
                const productNames = [
                    'LA-cook Gran',
                    'LA-cook Gran-pot',
                    '庫内比較'
                ];
                const bullet = `<span class="${className}">${productNames[index]}</span>`;
                return bullet;
            },
        },
    });
    //ラ・クックグランのヒミツ
    $(".video-open").modaal({
        type: 'video',
        overlay_close:true,
        background: '#000',
        overlay_opacity:0.8,
        before_open:function(){
            $('html').css('overflow-y','hidden');
        },
        after_close:function(){
            $('html').css('overflow-y','scroll');
        }
    });
    //商品紹介
    const productSwiper = new Swiper(".swiper-lacookgran", {
        slidesPerView: 1,
        effect: 'fade',
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
            waitForTransition: false,
        },
        pagination: {
            el: ".swiper-lacookgran-pagination",
            clickable: true,
        },
    });
    //製品番号の確認方法
    $('.title-find_product_number').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).next('.inner-find_product_number').slideUp();
        } else {
            $('.title-find_product_number').removeClass('active');
            $('.inner-find_product_number').slideUp();

            $(this).addClass('active');
            $(this).next('.inner-find_product_number').slideDown();
        }
    });
    //販売店の検索方法
    $(".button-modal").modaal({
        type: 'inline',
        overlay_close:true,
        background: '#000',
        overlay_opacity:0.8,
        before_open:function(){
            $('html').css('overflow-y','hidden');
        },
        after_close:function(){
            $('html').css('overflow-y','scroll');
        }
    });
});